import { faBars, faX } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogPanel } from '@headlessui/react'
import { GeneralInformation } from '@/payload-types'
import { useState } from 'react'
import { CMSLink } from '../../../components/CMSLink'
import { Logo } from '../Logo'

export const MobileNav = ({ data }: { data: GeneralInformation }) => {
  const { navigationItems, logo } = data || []
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  function handleClick(e: React.MouseEvent<HTMLDivElement>) {
    const target = e.target as HTMLElement
    if (target.closest('a')) {
      setMobileMenuOpen(false)
    }
  }

  return (
    <>
      <header
        className={`
        bg-gray-100 
        fixed top-0 right-5 mt-3 
        border border-gray-400 
        rounded-lg lg:hidden
        ${mobileMenuOpen ? 'hidden' : ''}
        `}
      >
        <nav aria-label="Global" className="mx-auto flex items-center justify-end p-2 lg:px-8">
          <div className="flex lg:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-black"
            >
              <span className="sr-only">Open main menu</span>
              <FontAwesomeIcon icon={faBars} aria-hidden="true" className="size-6" />
            </button>
          </div>
          <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden z-100">
            <div className="fixed inset-0 z-100" />
            <DialogPanel
              onClickCapture={(e) => handleClick(e)}
              className="fixed inset-y-0 right-0 z-101 w-full overflow-y-auto bg-black px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
            >
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="w-full justify-end flex rounded-md p-2.5 text-gray-700"
              >
                <span className="sr-only">Close menu</span>
                <FontAwesomeIcon icon={faX} aria-hidden="true" className="size-6 text-white" />
              </button>
              <div className="text-right min-h-[85vh] flex flex-col">
                <div className="gap-y-4 pt-6 flex flex-col justify-end">
                  {navigationItems &&
                    navigationItems.map(({ id, links, linkWithMedia }) => {
                      if (links && links.length > 0) {
                        return (
                          <>
                            {links.map(({ id: link_id, link }) => (
                              <CMSLink
                                key={link_id}
                                className="font-semibold text-white"
                                {...link}
                                appearance="inline"
                              />
                            ))}
                          </>
                        )
                      } else if (linkWithMedia) {
                        return (
                          <CMSLink
                            key={id}
                            className="font-semibold text-white"
                            {...linkWithMedia}
                            appearance="inline"
                          />
                        )
                      }
                      return null
                    })}
                </div>
                {logo && <Logo logo={logo} className="flex justify-center  mt-auto" />}
              </div>
            </DialogPanel>
          </Dialog>
        </nav>
      </header>
    </>
  )
}
